import React from 'react'

const JSONOutput = ({ data }) => {
    return (
        <div className="space-y-2">
            <label className="block text-sm font-medium">JSON de Saída</label>
            <div className="w-full h-64 p-3 font-mono text-sm rounded-lg bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 overflow-auto text-gray-900 dark:text-white">
                <pre>{JSON.stringify(data, null, 2)}</pre>
            </div>
        </div>
    );
};

export default JSONOutput
